<template>
  <div class="breadcrumbs" :class="overrideClass">
    <div class="bc" v-for="(breadcrumb, i) in generatedBreadcrumbs" :key="i">
      <span>{{ getTitle(breadcrumb) }}</span>
      <i class="material-icons">keyboard_arrow_right</i>
    </div>
  </div>
</template>

<script>
import i18n from "../../plugins/i18n";

export default {
  name: "breadcrumb",
  props: {
    breadcrumbsProp: {
      type: Array,
      required: false
    },
    overrideClass: {
      type: Object,
      required: false
    }
  },
  methods: {
    getTitle(breadcrumb) {
      return breadcrumb.translate ? i18n.t(breadcrumb.title) : breadcrumb.title;
    },
    onClick(breadcrumb) {
      if (breadcrumb.to) {
        this.$router.push({ name: breadcrumb.to, params: breadcrumb.params });
      }
      if (breadcrumb.callback) {
        breadcrumb.callback();
      }
    }
  },
  computed: {
    generatedBreadcrumbs() {
      if (this.breadcrumbsProp) return this.breadcrumbsProp;
      const routes = this.$route.fullPath.split("/");
      const params = { ...this.$route.params };
      routes.splice(0, 1);

      // const translateRegex = /stores|explore|sex|recommendations|clothing/;

      if (params.sex) {
        delete params.sex;
      }

      const breadcrumbs = routes.map(route => {
        return {
          title: `breadcrumb.titles.${route}`,
          // translate: translateRegex.test(route),
          translate: true,
          to: route,
          params: params
        };
      });
      return [
        {
          title: "breadcrumb.titles.home",
          translate: true,
          to: "Home",
          params: this.$route.params
        },
        ...breadcrumbs
      ];
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.breadcrumbs {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}

.bc {
  display: flex;
  align-items: center;
  font-size: $font-xs;
  font-weight: 400;
  color: $brand-gray;
  cursor: pointer;

  span {
    font-size: $font-xs;
    margin-right: 0.5rem;
  }

  .material-icons {
    color: black;
    margin-right: 0.5rem;
  }

  &:hover {
    opacity: 0.6;
  }

  &:last-child {
    font-weight: 700;
    color: $brand-black;
    cursor: unset;

    &:hover {
      opacity: 1;
    }

    .material-icons {
      display: none;
    }
  }
}
</style>
